import Icons from './batteryIcons';

export default {
  name: 'tankStatus',
  /* eslint-disable max-len */
  // TODO: Replace this string literal w require('./tankStatus.html')
  template:
      `<div class="title">
        <h2>
          <small>
            <span>Tank Size: {{TankStatCtrl.size | number:0}} bbls.</span>
            <span ng-if="TankStatCtrl.name !== 'Summary' && TankStatCtrl.temp !== undefined"> | Temperature: {{TankStatCtrl.temp|number:1}}</span>
            <span ng-if="TankStatCtrl.name !== 'Summary' && TankStatCtrl.volt !== undefined"> |
              <img class="battery"
                   ng-src="{{TankStatCtrl.getBatteryImage(TankStatCtrl.volt)}}"
                   uib-tooltip="{{TankStatCtrl.volt}}v"
                   tooltip-placement="right"
              >
            </span>
          </small>
        </h2>
      </div>`,
  /* eslint-enable max-len */
  controller: TankStatusController,
  controllerAs: 'TankStatCtrl',
  bindings: {
    size: '<',
    name: '<',
    temp: '<',
    volt: '<'
  }
};

function TankStatusController() {
  const vm = this;
  const voltCompare = 2.9;

  vm.getBatteryImage = volt => volt >= voltCompare ? Icons.three : Icons.zeroRed;
}
